// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.e-custom-primary, .e-custom-primary:focus, .e-custom-primary:active {
    background-color: #2364aa;
    color: #fff;
    border-color: #2364aa;
    font-family: inherit;
    text-align:center;
    font-size: 12px !important;
    border-radius: 30px; /* Adjust the value to control the roundness of the corners */
    padding: 0 20px; /* Adjust padding as needed */
  
  }
  
  .e-custom-primary:hover{
    background-color: #2364aa;
    color: #fff;
    border-color: #495057;
    font-family: inherit;
   
  }
  .overflow-cell{
    height: 100px;
  }
  .e-custom-success, .e-custom-success:focus, .e-custom-success:active {
    background-color: #2CB34A;
    color: #fff;
    border-color: #2CB34A;
    font-family: inherit;
    text-align:center;
    font-size: 12px !important;
    border-radius: 30px; /* Adjust the value to control the roundness of the corners */
    padding: 0 20px; /* Adjust padding as needed */
  
  
  }
  .e-custom-success:hover{
    background-color: #2CB34A;
    color: #fff;
    border-color: #495057;
    font-family: inherit;
  }
  
  .e-custom-light, .e-custom-light:focus, .e-custom-light:active {
    background-color: #ffff;
    color: #2364aa;
    border-color: #ffff;
    font-family: inherit;
    text-align:center;
    font-size: 12px !important;
    border-radius: 30px; /* Adjust the value to control the roundness of the corners */
  
    padding: 0 20px; /* Adjust padding as needed */
  
  
  }
  .e-custom-light:hover{
    background-color: #ffff;
    color: #2364aa;
    border-color: #495057;
    font-family: inherit;
    
   
  }
  
  .e-custom-warning, .e-custom-warning:focus, .e-custom-warning:active {
    background-color: #ffda75;
    color: #30343f;
    border-color: #ffda75;
    font-family: inherit;
    text-align:center;
    font-size: 12px !important;
    border-radius: 30px; /* Adjust the value to control the roundness of the corners */
    padding: 0 20px; /* Adjust padding as needed */
  
  
  }
  .e-custom-warning:hover{
    background-color: #ffda75;
    color: #30343f;
    border-color: #495057;
    font-family: inherit;
   
  }
  .e-custom-danger, .e-custom-danger:focus, .e-custom-danger:active {
    background-color: #ff6b6b;
    color: #ffff;
    border-color: #ff6b6b;
    font-family: inherit;
    text-align:center;
    font-size: 12px !important;
    border-radius: 30px; /* Adjust the value to control the roundness of the corners */
    padding: 0 20px; /* Adjust padding as needed */
  
  
  }
  .e-custom-danger:hover{
    background-color: #ff6b6b;
    color: #ffff;
    border-color: #495057;
    font-family: inherit;
   
  }
  
  `, "",{"version":3,"sources":["webpack://./src/styles/Custombuttons.css"],"names":[],"mappings":";;;AAGA;IACI,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB,EAAE,6DAA6D;IAClF,eAAe,EAAE,6BAA6B;;EAEhD;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,oBAAoB;;EAEtB;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB,EAAE,6DAA6D;IAClF,eAAe,EAAE,6BAA6B;;;EAGhD;EACA;IACE,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB,EAAE,6DAA6D;;IAElF,eAAe,EAAE,6BAA6B;;;EAGhD;EACA;IACE,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,oBAAoB;;;EAGtB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB,EAAE,6DAA6D;IAClF,eAAe,EAAE,6BAA6B;;;EAGhD;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,oBAAoB;;EAEtB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB,EAAE,6DAA6D;IAClF,eAAe,EAAE,6BAA6B;;;EAGhD;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;;EAEtB","sourcesContent":["\r\n\r\n\r\n.e-custom-primary, .e-custom-primary:focus, .e-custom-primary:active {\r\n    background-color: #2364aa;\r\n    color: #fff;\r\n    border-color: #2364aa;\r\n    font-family: inherit;\r\n    text-align:center;\r\n    font-size: 12px !important;\r\n    border-radius: 30px; /* Adjust the value to control the roundness of the corners */\r\n    padding: 0 20px; /* Adjust padding as needed */\r\n  \r\n  }\r\n  \r\n  .e-custom-primary:hover{\r\n    background-color: #2364aa;\r\n    color: #fff;\r\n    border-color: #495057;\r\n    font-family: inherit;\r\n   \r\n  }\r\n  .overflow-cell{\r\n    height: 100px;\r\n  }\r\n  .e-custom-success, .e-custom-success:focus, .e-custom-success:active {\r\n    background-color: #2CB34A;\r\n    color: #fff;\r\n    border-color: #2CB34A;\r\n    font-family: inherit;\r\n    text-align:center;\r\n    font-size: 12px !important;\r\n    border-radius: 30px; /* Adjust the value to control the roundness of the corners */\r\n    padding: 0 20px; /* Adjust padding as needed */\r\n  \r\n  \r\n  }\r\n  .e-custom-success:hover{\r\n    background-color: #2CB34A;\r\n    color: #fff;\r\n    border-color: #495057;\r\n    font-family: inherit;\r\n  }\r\n  \r\n  .e-custom-light, .e-custom-light:focus, .e-custom-light:active {\r\n    background-color: #ffff;\r\n    color: #2364aa;\r\n    border-color: #ffff;\r\n    font-family: inherit;\r\n    text-align:center;\r\n    font-size: 12px !important;\r\n    border-radius: 30px; /* Adjust the value to control the roundness of the corners */\r\n  \r\n    padding: 0 20px; /* Adjust padding as needed */\r\n  \r\n  \r\n  }\r\n  .e-custom-light:hover{\r\n    background-color: #ffff;\r\n    color: #2364aa;\r\n    border-color: #495057;\r\n    font-family: inherit;\r\n    \r\n   \r\n  }\r\n  \r\n  .e-custom-warning, .e-custom-warning:focus, .e-custom-warning:active {\r\n    background-color: #ffda75;\r\n    color: #30343f;\r\n    border-color: #ffda75;\r\n    font-family: inherit;\r\n    text-align:center;\r\n    font-size: 12px !important;\r\n    border-radius: 30px; /* Adjust the value to control the roundness of the corners */\r\n    padding: 0 20px; /* Adjust padding as needed */\r\n  \r\n  \r\n  }\r\n  .e-custom-warning:hover{\r\n    background-color: #ffda75;\r\n    color: #30343f;\r\n    border-color: #495057;\r\n    font-family: inherit;\r\n   \r\n  }\r\n  .e-custom-danger, .e-custom-danger:focus, .e-custom-danger:active {\r\n    background-color: #ff6b6b;\r\n    color: #ffff;\r\n    border-color: #ff6b6b;\r\n    font-family: inherit;\r\n    text-align:center;\r\n    font-size: 12px !important;\r\n    border-radius: 30px; /* Adjust the value to control the roundness of the corners */\r\n    padding: 0 20px; /* Adjust padding as needed */\r\n  \r\n  \r\n  }\r\n  .e-custom-danger:hover{\r\n    background-color: #ff6b6b;\r\n    color: #ffff;\r\n    border-color: #495057;\r\n    font-family: inherit;\r\n   \r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
